module.exports = __webpack_public_path__ + "img/ico-check-green-quest.d7976e2f.svg";